import { ReactNode, forwardRef } from 'react';
import { CommonFieldAtomProps } from '../atoms/types';
import { FieldWrapperStyles } from './field-wrapper.styles';

// TODO: add color theming prop so it can be used on non-white bgs
// need input from design on what those options and styles should be
interface FieldWrapperProps extends Omit<CommonFieldAtomProps, 'id'> {
  className?: string;
  mode?: 'light' | 'dark';
  children: ReactNode;
  hasPadding?: boolean;
}

export const FieldWrapper = forwardRef<HTMLDivElement, FieldWrapperProps>(
  ({ active, children, disabled, hasError, hasPadding, ...props }, ref) => {
    const styles = FieldWrapperStyles.fieldWrapper({ disabled, hasError, active, hasPadding });

    return (
      <div css={styles} {...props} ref={ref}>
        {children}
      </div>
    );
  }
);
